import React from "react";

import classNames from "classnames";

import ScrollAnimation from "react-animate-on-scroll";

import { useTheme, makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import Code from "@material-ui/icons/Code";
import FormatPaint from "@material-ui/icons/FormatPaint";
import Dashboard from "@material-ui/icons/Dashboard";
import ViewCarousel from "@material-ui/icons/ViewCarousel";
import AccessTime from "@material-ui/icons/AccessTime";
import AttachMoney from "@material-ui/icons/AttachMoney";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";


import bg3 from "images/bg2.jpg";
import ProcessSectionStyle from "./ProcessSectionStyle";


const useStyles = makeStyles(ProcessSectionStyle);

const ProcessSection = () => {
    const classes = useStyles();
    const theme = useTheme();

    const underXs = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <div
            className={classes.features5}
            style={{ backgroundImage: `url(${bg3})` }}
        >
            <GridContainer>
                <GridItem
                    xs={12} sm={8} md={8}
                    className={classNames(classes.mlAuto, classes.mrAuto, classes.textCenter)}>

                    <h2 className={classes.title} style={{fontFamily: 'Noto Sans KR', fontSize: underXs ? '1.8rem' : null}}>
                        <ScrollAnimation animateIn="fadeIn" duration={1} animateOnce={true}>
                        개발 프로세스
                        </ScrollAnimation>
                    </h2>
                </GridItem>
                <div className={classes.container}>
                    <GridContainer className={classes.gridContainer}>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                            <InfoArea
                                vertical
                                className={classes.infoArea5}
                                icon={Code}
                                title="1. 상담 및 견적"
                                description={
                                    <p>
                                        고객의 요구사항을 듣고 해결 방안을 모색하여 가장 적합한 솔루션을 찾아냅니다. 프로젝트를 진행하기 전 궁금한 모든 것을 물어보세요.
                                    </p>
                                }
                                iconColor="info"
                            />
                            </ScrollAnimation>
                        </GridItem>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                            <InfoArea
                                vertical
                                className={classes.infoArea5}
                                icon={FormatPaint}
                                title="2. 계약 체결"
                                description={
                                    <p>
                                        젠가블록과 함께하기로 결정하는 순간입니다. 앞으로 진행될 사항들과 내용을 꼼꼼히 확인하여 서로 약속합니다.
                                    </p>
                                }
                                iconColor="danger"
                            />
                            </ScrollAnimation>
                        </GridItem>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                            <InfoArea
                                vertical
                                className={classes.infoArea5}
                                icon={Dashboard}
                                title="3. 기획"
                                description={
                                    <p>
                                        훌륭한 결과를 위해서는 튼튼한 기획이 기반이 되어야 합니다. 필요한 기능 및 흐름을 정립하여 보다 안정된
                                        제품 개발이 이루어질 수 있도록 합니다.
                                    </p>
                                }
                                iconColor="primary"
                            />
                            </ScrollAnimation>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.gridContainer}>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                            <InfoArea
                                vertical
                                className={classes.infoArea5}
                                icon={ViewCarousel}
                                title="4. 디자인 및 개발"
                                description={
                                    <p>
                                        최고의 디자이너와 프로그래머들이 함께 개발에 착수합니다.
                                        짧은 주기로 개발내용을 고객과 공유하여 진행상황을 언제든지 확인할 수 있습니다.
                                    </p>
                                }
                            />
                            </ScrollAnimation>
                        </GridItem>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                            <InfoArea
                                vertical
                                className={classes.infoArea5}
                                icon={AccessTime}
                                title="5. 앱 테스트"
                                description={
                                    <p>
                                        정교한 테스트가 견고한 제품을 만들어냅니다. 전문 테스터들이 까다로운 기준으로 고객과 함께 앱을 테스트하여,
                                        안정된 제품이 출시될 수 있도록 합니다.
                                    </p>
                                }
                            />
                            </ScrollAnimation>
                        </GridItem>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                            <InfoArea
                                vertical
                                className={classes.infoArea5}
                                icon={AttachMoney}
                                title="6. 개발 완료"
                                description={
                                    <p>
                                        제품 개발이 완료되어 출시 됩니다.
                                        이제부터는 사용자들의 요구와 반응에 따라 제품을 지속적으로 업데이트 해 나갑니다.
                                    </p>
                                }
                            />
                            </ScrollAnimation>
                        </GridItem>
                    </GridContainer>
                    <GridContainer className={classes.gridContainer}>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                                <InfoArea
                                    vertical
                                    className={classes.infoArea5}
                                    icon={ViewCarousel}
                                    title="7. 스토어 등록"
                                    description={
                                        <p>
                                            너드앤포드는너 드앤포드 는너 드앤포드는 너드앤포 드는너드앤포드는너드 앤포드는너 드앤포드 는너드앤 포드는너드앤포 드는너 드앤 포드는
                                        </p>
                                    }
                                />
                            </ScrollAnimation>
                        </GridItem>
                        <GridItem xs={12} sm={4} className={classes.gridItem}>
                            <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                                <InfoArea
                                    vertical
                                    className={classes.infoArea5}
                                    icon={AccessTime}
                                    title="8. 유지 및 보수"
                                    description={
                                        <p>
                                            너드앤포드는 멘트 생각해오기 주원씨가 헤헤헤헤. 멘트 너무 어렵다요. 헤헤헤헤. 너드앤포드는 멘트 생각해오기 주원씨가 헤헤헤헤. 멘트 너무 어렵다요. 헤헤헤헤.
                                        </p>
                                    }
                                />
                            </ScrollAnimation>
                        </GridItem>
                        {
                            !underXs &&
                            <GridItem xs={12} sm={4} className={classes.gridItem}>
                                <ScrollAnimation animateIn="fadeInUpSmall" duration={1} animateOnce={true}>
                                    <InfoArea
                                        vertical
                                        className={classes.infoArea5}
                                        icon={""}
                                        title=""
                                        description={""}
                                    />
                                </ScrollAnimation>
                            </GridItem>
                        }
                    </GridContainer>
                </div>
            </GridContainer>
        </div>
    );
};

export default ProcessSection;
